<template>
	<nut-navbar
		class="navbar"
		title="更换设备头像"
		fixed
		:placeholder="false"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<a
				@click.prevent.stop="handleSaveAvatar"
				class="right"
				href="javascript:;"
			>
				保存
			</a>
		</template>
	</nut-navbar>
	<div class="avatars">
		<div
			class="avatar"
			v-for="item in iconList"
			:key="item.id"
			@click="handleChangeIcon(item.id)"
		>
			<nut-avatar
				:key="item"
				shape="square"
				size="normal"
				:icon="item.url"
				style="width: 44px; height: 44px"
			></nut-avatar>
			<div v-if="currentIconId === item.id" class="mask">
				<nut-icon name="Check" color="#00adee" size="24"> </nut-icon>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted, ref } from 'vue';
import useNavigate from '@/hooks/useNavigate';
import { settingApi } from '@/apis';
import { Toast } from '@nutui/nutui';

export default {
	name: 'Icon',
	data() {
		const { goBack } = useNavigate();
		const currentIconId = ref('');
		const iconList = ref([]);

		const handleSaveAvatar = async () => {
			await settingApi.icon_save({
				id: currentIconId.value,
			});
			Toast.success('保存成功', {
				duration: 1000,
				onClose() {
					goBack();
				},
			});
		};

		const handleChangeIcon = (id) => {
			currentIconId.value = id;
		};

		const getCurrentId = (list = []) => {
			const filterItem = list.filter((item) => item.on)[0];
			return filterItem ? filterItem.id : '';
		};

		onMounted(async () => {
			const list = await settingApi.icon_load_data();
			iconList.value = list;
			currentIconId.value = getCurrentId(list);
		});

		return {
			iconList,
			currentIconId,

			goBack,
			handleSaveAvatar,
			handleChangeIcon,
		};
	},
};
</script>

<style lang="scss" scoped>
.navbar {
	.right {
		color: #fff;
	}
}
.avatars {
	margin-top: $navbar-height;
	padding: 10px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	.avatar {
		position: relative;
		box-sizing: border-box;
		width: 20%;
		height: 44px;
		text-align: center;
		margin-bottom: 6px;
	}

	.mask {
		@include flex-center;
		justify-content: center;
		position: absolute;
		left: 50%;
		top: 0;
		width: 44px;
		height: 44px;
		margin-left: -22px;
		background-color: rgba(0, 0, 0, 0.35);
	}
}
</style>
